import axios from "@/utils/request";
import { snkd } from "@/api/api";

import send from "@/api/lib";
import { getStorage } from "@/utils/storage";

const { companyId, farmId } = getStorage("FARMINFO") || "";

// 通过code获取农场是否展示ai标签提示
export const getFarmModulesByCode = (params) => {
  return axios.post(snkd.produce.farmsModules.getFarmModulesByCode, {
    ...params,
    farmId,
  });
};

// 神农链url查询接口
export const getSnlUrls = (params) => {
  return axios.post(snkd.produce.certificate.getQRCodeUrls, {
    ...params,
    farmId,
  });
};
// 补贴分析列表
export const getSubsidyStaticsList = (params) => {
  return axios.post(snkd.produce.subsidyStatics.list, {
    ...params,
    farmId,
  });
};
// 补贴分析详情
export const getSubsidyStaticsDetail = (params) => {
  return axios.post(snkd.produce.subsidyStatics.detail, params);
};
// 神农口袋基本信息--金融信息所有下拉框数据
export const getAllSelectData = () => {
  return axios.get(snkd.produce.companyFinanceInfo.selectData);
};
// 神农口袋基本信息--金融信息提交表单
export const addFinance = (params) => {
  return axios.post(snkd.produce.companyFinanceInfo.add, params);
};

// 神农口袋基本信息--金融信息详情
export const getFinanceList = (params) => {
  return axios.get(`${snkd.produce.companyFinanceInfo.detail}/${params.id}`);
};

// 数据上链--上链数据表
export const getDataUplinkList = (params) => {
  return axios.get(`${snkd.produce.dataUplink.list}/${params.farmId}`);
};

//数据上链--数据上链品种列表
export const getUplinkCropList = (params) => {
  return axios.post(snkd.produce.dataUplink.uplinkCropList, params);
};
//数据上链--删除数据上链品种列表
export const delUplinkCrop = (params) => {
  return axios.delete(`${snkd.produce.dataUplink.delUplinkCrop}/${params.id}`);
};
// 数据上链--地块上链填报
export const addDataUplink = (params) => {
  return axios.post(snkd.produce.dataUplink.add, params);
};

// 数据上链--地块上链填报查询
export const getDataUplinkDetail = (params) => {
  return axios.get(`${snkd.produce.dataUplink.detail}/${params.id}`);
};
// 已开具合格证列表
export const getCertificateListForStorage = (params) => {
  return axios.post(snkd.produce.certificate.getStorageList, {
    ...params,
    companyId,
    farmId,
  });
};

export const getCertificateListForStorageDetail = (params) => {
  return axios.post(snkd.produce.certificate.getstorageDetail, {
    ...params,
  });
};
// 已开具合格证列表
export const getCertificateList = (params) => {
  return axios.post(snkd.produce.certificate.getList, {
    ...params,
    companyId,
    farmId,
  });
};
// 已开具合格证详情
export const getCertificateDetail = (params) => {
  return axios.post(snkd.produce.certificate.getDetail, params);
};
// 已开具合格证详情列表
export const getCertificateDetailList = (params) => {
  return axios.post(snkd.produce.certificate.queryCertificateDetailList, {
    ...params,
    companyId,
    farmId,
  });
};
//仓储加工-入仓信息
export const insertOrUpdateOne = (params) => {
  return axios.post(snkd.produce.storageProcess.InputWarehouseData, {
    ...params,
  });
};
//仓储加工-出仓信息
export const insertOrUpdateTwo = (params) => {
  return axios.post(snkd.produce.storageProcess.OutputWarehouseData, {
    ...params,
  });
};
//仓储加工-加工
export const insertOrUpdateThree = (params) => {
  return axios.post(snkd.produce.storageProcess.OutputProcessData, {
    ...params,
  });
};
//仓储加工-检测报告
export const insertOrUpdateFour = (params) => {
  return axios.post(snkd.produce.storageProcess.ProcessInspectReport, {
    ...params,
  });
};
//仓储加工-物码信息
export const ProductCodeInfo = (params) => {
  return axios.post(snkd.produce.storageProcess.ProductCodeInfo, {
    ...params,
  });
};
//鸡蛋-仓储加工-加工信息列表
export const getStorageEggDetail = (params) => {
  return axios.post(snkd.produce.storageProcessEgg.getStorageEggDetail, {
    ...params,
  });
};
//鸡蛋-仓储加工-监测信息列表
export const getProcessInspectReportList = (params) => {
  return axios.get(
    `${snkd.produce.storageProcessEgg.getProcessInspectReportList}/${params.id}`
  );
};
//鸡蛋-仓储加工-加工产品名称下拉
export const getProductList = (params) => {
  return axios.post(snkd.produce.storageProcessEgg.productList, {
    ...params,
  });
};
//鸡蛋-仓储加工-添加加工
export const insertOrUpdateThreeForEgg = (params) => {
  return axios.post(snkd.produce.storageProcessEgg.addOutputProcessData, {
    ...params,
  });
};

//鸡蛋-仓储加工-添加检测报告
export const insertOrUpdateFourForEgg = (params) => {
  return axios.post(snkd.produce.storageProcessEgg.ProcessInspectReportEgg, {
    ...params,
  });
};
// 获取神农码qrcode的url
export const getSnmQrcodeUrl = (params) => {
  return axios.post(snkd.produce.certificate.getSnmQrcodeUrl, params);
};
// 新增合格证qrcode的url
export const addCertificateQrcodeUrl = (params) => {
  return axios.post(snkd.produce.certificate.addQrcodeUrl, params);
};
// 获取合格证qrcode的url
export const getCertificateQrcodeUrl = (params) => {
  return axios.post(snkd.produce.certificate.getQrcodeUrl, params);
};
// 已开具合格证列表数量
export const getCertificateListCount = (params) => {
  return axios.post(snkd.produce.certificate.getListCount, {
    ...params,
    companyId,
    farmId,
  });
};
// 获取合格证qrcode的url
export const unBindStationApi = (params) => {
  return axios.post(snkd.produce.certificate.unBindStation, params);
};
// 获取合格证qrcode的url
export const chooseDefaultStationApi = (params) => {
  return axios.post(snkd.produce.certificate.chooseDefaultStation, params);
};
// 获取农场绑定得远程打印站点信息
export const getCertificateStationList = (params) => {
  return axios.post(snkd.produce.certificate.getStationList, {
    ...params,
    companyId,
    farmId,
  });
};
/**
 * @description 添加合格证二维码短链接
 * @param { Object } params 添加参数
 * @param { String } params.certificateCode 合格证编号
 * @param { String } params.linkUrl 真实的合格证二维码链接
 * @param { Number }  params.qrcodeType 二维码类别: 1-系统合格证; 2-申农码
 * @returns { Promise<{*}> }
 */
export const addCertificateQRCodeShortLink = (params) => {
  return axios.post(snkd.produce.certificate.addCertificateQRCodeShortLink, {
    ...params,
    companyId,
    farmId,
  });
};

/**
 * @description 合格证(白名单相关配置)
 * @param { Object } params 查询参数
 * @param { String } params.companyId 企业id
 * @returns { Promise<{*}> }
 */
export const getShangHaiCertificateWhiteConfig = (params = {}) => {
  return axios.post(snkd.produce.certificate.shangHaiCertificateWhiteConfig, {
    ...params,
    companyId,
    farmId,
  });
};

// 生成批次接口
export const generateTaskList = (params) => {
  return axios.post(snkd.produce.task.generateTask, {
    ...params,
    companyId,
    farmId,
  });
};
// 根据批次号生成打印记录
export const generatePrintRecordList = (params) => {
  return axios.post(snkd.produce.task.generatePrintRecord, {
    ...params,
    companyId,
    farmId,
  });
};
// 根据批次号 获取合格证信息 批量打印用
export const getCertificateInfoByTask = (params) => {
  return axios.post(snkd.produce.task.pageCertificateByTask, {
    ...params,
    companyId,
    farmId,
  });
};
// 查询打印记录 批次列表
export const getPageTaskList = (params) => {
  return axios.post(snkd.produce.task.getPageTask, {
    ...params,
    companyId,
    farmId,
  });
};
// 根据批次id 查询批次列表明细
export const getPageTaskDetail = (params) => {
  return axios.post(snkd.produce.task.getPageTaskDetail, {
    ...params,
    companyId,
    farmId,
  });
};
// 根据批次 查询打印信息
export const queryPrintTaskDetail = (params) => {
  return axios.post(snkd.produce.task.queryPrintTaskDetail, {
    ...params,
    companyId,
    farmId,
  });
};
// 种源列表
export const seedSourcePageList = (params) => {
  return axios.post(snkd.produce.seedSourceManagement.pageList, {
    ...params,
    companyId,
    farmId,
  });
};
export const agriResPackUnit = () => {
  return axios.post(snkd.produce.seedSourceManagement.agriResPackUnit, {
    companyId,
  });
};
export const insertOrUpdate = (params) => {
  return axios.post(snkd.produce.seedSourceManagement.insertOrUpdate, {
    ...params,
    companyId,
    farmId,
  });
};
export const listAll = () => {
  return axios.post(snkd.produce.seedSourceManagement.listAll, {
    companyId,
    farmId,
  });
};
export const listCropCategory = (id) => {
  return axios.get(snkd.produce.seedSourceManagement.listCropCategory + id);
};
export const getById = (id) => {
  return axios.get(snkd.produce.seedSourceManagement.getById + id);
};
export const selectList = (params) => {
  return axios.post(snkd.produce.seedSourceManagement.selectList, {
    ...params,
    companyId,
    farmId,
  });
};
export const deleteByIds = (params) => {
  return axios.post(snkd.produce.seedSourceManagement.deleteByIds, {
    ...params,
  });
};

// 神农口袋销售模块--添加
export const apiSellRecordAdd = (params) => {
  return axios.post(snkd.produce.sellRecord.add, params);
};
export const sellEnterpriseadd = (params) => {
  return axios.post(snkd.produce.sellRecord.sellEnterpriseadd, params);
};
// 销售企业列表
export const urlCompanyList = (params) => {
  return axios.post(snkd.produce.sellRecord.urlCompanyList, params);
};
// 神农口袋销售模块--检查
export const apiSellRecordCheck = (params) => {
  return axios.post(snkd.produce.sellRecord.check, params);
};
// 神农口袋销售模块--添加图片
export const apiSellImg = (params) => {
  return axios.post(snkd.produce.sellRecord.addImg, params);
};
// 神农口袋销售模块--根据id获取详情
export const apiSellDetail = (params) => {
  return axios.get(snkd.produce.sellRecord.detail + `${params}`);
};
export const apiSellnewDetail = (params) => {
  return axios.get(snkd.produce.sellRecord.record_detail + `${params}`);
};
export const downloadstock = (params_va) => {
  let params = {
    responseType: "blob",
    getResponse: true,
  };
  return axios.get(
    snkd.produce.sellRecord.downloadstock +
      `${params_va.farmId}/${params_va.dataOrigin}`,
    params
  );
};

//添加农产品
export const addCrop = (params) => {
  return axios.post(snkd.produce.crop.addCrop, params);
};

// 作物
export const getCrop = (params) => {
  return axios.post(snkd.produce.crop.crop, params);
};

//采收产品列表
export const getCropList = (params) => {
  return axios.post(snkd.produce.crop.cropIdList, params);
};

//航育表单保存并提交审核
export const saveAndAudit = (params) => {
  return axios.post(snkd.produce.mission.saveAndAudit, params);
};

//航育表单保存
export const saveMission = (params) => {
  return axios.post(snkd.produce.mission.save, params);
};

//航育详情
export const getDetail = (params) => {
  return axios.post(snkd.produce.mission.detail, params);
};

//航育删除
export const getDel = (params) => {
  return axios.post(snkd.produce.mission.del, params);
};

//航育批量删除
export const getBatchDel = (params) => {
  return axios.post(snkd.produce.mission.batchDel, params);
};

//航育批量审核
export const getBatchAudit = (params) => {
  return axios.post(snkd.produce.mission.batchAudit, params);
};

//航育自动审核
export const getAutoAuditByDay = (params) => {
  return axios.post(snkd.produce.mission.autoAuditByDay, params);
};

//获取航育农事列表
export const getMissionList = (params) => {
  return axios.post(snkd.produce.mission.list, params);
};

//获取航育农事类型
export const getMissionCategoryList = (params) => {
  return axios.post(snkd.produce.mission.missionCategoryList, params);
};

//获取系统农资列表
export const addAgri = (params) => {
  return axios.post(snkd.produce.agricProduct.add, params);
};

//获取系统农资列表
export const getAgriListSummary = (params) => {
  return axios.post(snkd.produce.agricProduct.getAgriListSummary, params);
};

//获取已出库待使用农资
export const getAgriResReceiveSkuList = (params) => {
  return axios.post(snkd.produce.agricProduct.getAgriResReceiveSkuList, params);
};

export const outsourcingInfoAdd = (params) => {
  return axios.post(snkd.produce.agricProduct.outsourcingInfoAdd, params);
};

export const supplyEnterpriseAdd = (params) => {
  return axios.post(snkd.produce.agricProduct.supplyEnterpriseAdd, params);
};

//获取种植标准列表
export const getPlantStandardList = (params) => {
  return axios.post(snkd.produce.crop.plantStandardList, params);
};

// 获取受灾列表
export const getDamageList = (params) => {
  return axios.post(snkd.produce.damage.list, params);
};

// 上调受灾程度
export const raisedLevel = (params) => {
  return axios.post(snkd.produce.damage.raisedLevel, params);
};

// 获取受灾详情
export const getDamageDetail = (params) => {
  return axios.post(snkd.produce.damage.sum, params);
};

// 获取受灾地块列表
export const getDamagelabdList = (params) => {
  return axios.post(snkd.produce.damage.landList, params);
};

// 添加受灾地块列表
export const addDamagelabdList = (params) => {
  return axios.post(snkd.produce.damage.add, params);
};

// 添加受灾地块列表
export const repeatDamagelabdList = (params) => {
  return axios.post(snkd.produce.damage.repeat, params);
};

// 批量添加受灾地块列表
export const repeatBatchDamagelabdList = (params) => {
  return axios.post(snkd.produce.damage.repeatBatch, params);
};

// 获取受灾地块详情
export const getDamagelabdInfo = (id) => {
  return axios.get(`${snkd.produce.damage.get}/${id}`, {});
};

// 获取批量审查受灾地块列表
export const getDamageChooselandList = (params) => {
  return axios.post(snkd.produce.damage.chooseLandList, params);
};

// 获取农场信息
export const getFarmInfo = (params) => {
  return axios.post(snkd.produce.farm.get, params);
};

// 获取用户所有的农场
export const getAllFarmByCompanyId = (params) => {
  return axios.post(snkd.produce.farm.list, params);
};
//获取当前农场种养品种
export const getCropByCompanyId = (params) => {
  return axios.post(snkd.produce.crop.listOfCropByFarmId, params);
};

//获取地块分组
export const getLandGroup = (params) => {
  return axios.get(
    snkd.produce.land.getLandGroup +
      `?companyId=${params.companyId}&farmId=${params.farmId}`
  );
};
//获取地块数据
export const getLandList = (params) => {
  return axios.post(snkd.produce.land.getLandList, params);
};

// 获取所有作物
// export const getAllCrop = (params) => {
//   return axios.post(snkd.produce.crop.listAll, params);
// };

// 获取订单列表 listSummary
export const getOrderlist = (params) => {
  return axios.post(snkd.produce.farmInsureOrder.listSummary, params);
};

// 获取订单详情
export const getOrderDetail = (params) => {
  return axios.post(snkd.produce.farmInsureOrder.get, params);
};
//取消订单
export const delOrdercancel = (params) => {
  return axios.post(snkd.produce.farmInsureOrder.cancel, params);
};

// 订单付款链接 getPayUrl
export const getPayUrl = (params) => {
  return axios.post(snkd.produce.farmInsureOrder.getPayUrl, params);
};
// 付费通知打印链接 offlinePayment
export const getofflinePayment = (params) => {
  return axios.post(snkd.produce.farmInsureOrder.offlinePayment, params);
};

// 获取可投保作物
export const getSeCropGroup = (params) => {
  return axios.post(snkd.produce.farmInsurePolicy.listSelectCropGroup, params);
};
// 获取可投保地块
export const getSelectLand = (params) => {
  return axios.post(snkd.produce.farmInsurePolicy.listSelectLand, params);
};

// 获取保单列表
export const getInsurancelist = (params) => {
  return axios.post(snkd.produce.farmInsurePolicy.listSummary, params);
};

// 获取保单详情
export const getdetailsInsure = (params) => {
  return axios.post(snkd.produce.farmInsurePolicy.get, params);
};
// 获取投保人信息
export const getByFarmIdUserInfo = (params) => {
  return axios.post(snkd.produce.farmInsure.getByFarmId, params);
};

// ----------------------------》〉》〉》
// 获取投保介绍和规则
export const getInsureInfo = (params) => {
  return axios.post(snkd.produce.insure.list, params);
};

// 获取险种 id（列表第一项的）
export const getInsureId = async () => {
  const params = {
    enableFlag: 1, // 开启的险种，0 是禁用
    pageNo: 1,
    pageSize: 10,
  };
  return axios.post(snkd.produce.insure.list, params);
};

// 获取投保地块
export const getInsureLandList = (params) => {
  return axios.post(snkd.produce.land.listInsureOrderLand, params);
};

// 查询符合投保标准
export const checkEnableInsure = (params) => {
  return axios.post(snkd.produce.land.checkEnableByFarmIdAndInsureId, params);
};

// 添加投保人信息
export const addInsureInfo = (params) => {
  return axios.post(snkd.produce.farmInsure.add, params);
};

// 获取投保人信息
export const getInsureInfoByFarmId = (params) => {
  return axios.post(snkd.produce.farmInsure.getByFarmId, params);
};

// 获取险种投保最小面积
export const getInsureDetail = (params) => {
  return axios.post(snkd.produce.farmInsure.getInsureById, params);
};

// 添加投保订单
export const addFarmInsureOrder = (params) => {
  return axios.post(snkd.produce.farmInsureOrder.add, params, {
    timeout: 600000,
  });
};

//获取投保人白名单
export const getPolicyholderInfo = (params) => {
  return axios.post(
    `${snkd.produce.farmInsureOrder.policyholderInfo}?companyId=${params.companyId}`
  );
};

//添加投保人白名单
export const getPolicyholderAdd = (params) => {
  return axios.post(snkd.produce.farmInsureOrder.policyholderAdd, {
    ...params,
  });
};
//修改投保人白名单
export const getPolicyholderUpdate = (params) => {
  return axios.post(snkd.produce.farmInsureOrder.policyholderUpdate, {
    ...params,
  });
};
//获取投保人白名单id
export const getPolicyholderGetByFarmId = (params) => {
  return axios.post(snkd.produce.farmInsureOrder.policyholderGetByFarmId, {
    ...params,
  });
};

// 添加投保人信息
export const addPersonInfo = (params) => {
  return axios.post(snkd.produce.farmInsureOrder.addPerson, params);
};
// 获取投保人信息列表
export const getpersonList = (params) => {
  return axios.post(snkd.produce.farmInsureOrder.personList, params);
};

//修改投保人信息
export const editPersonInfo = (params) => {
  return axios.post(snkd.produce.farmInsureOrder.editPerson, params);
};
//删除投保人信息
export const delPersonInfo = (params) => {
  return axios.get(`${snkd.produce.farmInsureOrder.delPerson}/${params.id}`);
};
// 获取银行列表
export const getBankList = (params) => {
  return axios.post(snkd.produce.insureBank.bankList, params);
};

// 获取银行支行
export const getBranchBankList = (params) => {
  return axios.post(snkd.produce.insureBank.branchList, params);
};

// 校验选中地块总面积是否符合最小投保面积
export const checkMinAcre = (params) => {
  return axios.post(snkd.produce.farmInsureOrder.checkMinAcre, params);
};

// 获取上海 gis服务token
export const getGisTokenByPost = () => {
  return axios.post(snkd.produce.token.get, {});
};

// 获取神农口袋 gis 服务token
export const getGisSnTokenByPost = () => {
  return axios.post(snkd.produce.token.getSnToken, {});
};

export const getRuralInsurableLandList = (params) => {
  return axios.post(snkd.produce.ruralInsurance.listSYInsurerLand, params);
};
//穗优保险模块
export const ruralInsurance = {
  // // 获取保单列表
  getRuralList(params = {}) {
    return axios.post(snkd.produce.ruralInsurance.ruralInsuranceList, params);
  },
  //提交穗优保险意向
  addRuralInsureOrder(params = {}) {
    return axios.post(snkd.produce.ruralInsurance.addInsurance, params);
  },
  //获取投保地块
  getRuralInsuranceLandList(params = {}) {
    return axios.post(snkd.produce.ruralInsurance.listSYInsurerLand, params);
  },
  //  获取保单人信息详情
  getInsurePolicyGet(params = {}) {
    return axios.get(
      snkd.produce.ruralInsurance.ruralGetDetail + `/${params.id}`
    );
  },
  //获取保单地块信息详情
  getInsurePolicyLand(params = {}) {
    return axios.get(
      snkd.produce.ruralInsurance.ruralLandDetail + `/${params.id}`
    );
  },
  // 投保意向单记录
  getInsureOrderListSummary(params = {}) {
    return axios.post(
      snkd.produce.ruralInsurance.insureOrderListSummary,
      params
    );
  },
  // 投保意向单信息 | 投保地块信息
  getInsureOrderDetail(params = {}) {
    return axios.post(snkd.produce.ruralInsurance.insureOrderDetail, params);
  },
  // 投保人信息(投保意向单)
  getInsureGetByFarmId(params = {}) {
    return axios.post(snkd.produce.ruralInsurance.insureGetByFarmId, params);
  },
};
//质量快检
export const qualityInspection = {
  //获取机构列表
  getQualityCompanyListServe() {
    return axios.get(snkd.produce.qualityInspection.companyList);
  },
  //获取检查项目下拉
  getProjectItemServe(params = {}) {
    return axios.get(
      snkd.produce.qualityInspection.projectItem +
        `?companyId=${params.companyId}&thirdCompanyId=${params.thirdCompanyId}`
    );
  },
  //获取机构列表
  getQualityResultListServe(params = {}) {
    return axios.post(snkd.produce.qualityInspection.resultList, params);
  },
  //获取结果详情
  getQualityResultDetailListServe(params = {}) {
    return axios.get(
      snkd.produce.qualityInspection.resultDetail + `/${params.id}`
    );
  },
  //绑定信息-添加
  getAddBindServe(params = {}) {
    return axios.post(snkd.produce.qualityInspection.bindAdd, params);
  },
  //绑定信息-编辑
  getEditBindServe(params = {}) {
    return axios.post(snkd.produce.qualityInspection.bindEdit, params);
  },
  //绑定信息-回显
  getBindServe(params = {}) {
    return axios.get(
      snkd.produce.qualityInspection.bindGet + `?companyId=${params.companyId}`
    );
  },
};

const CoCameraListReq = {
  farmId: 0, // 农场id
  pageNo: 0,
  pageSize: 0,
};
const CoDeviceListReq = {
  farmId: 0,
  pageNo: 0,
  pageSize: 0,
};
const CoDeviceDetailReq = {
  deviceId: 0, // 设备id
  farmId: 0,
};
const CoDevicePropertyGetReq = {
  deviceId: 0,
  devicePropertyId: 0, // 设备属性id
  farmId: 0,
};
const CoDeviceAttrHistoryReq = {
  dateNum: 0, // dateType=1固定天数时的具体天数，取值：1,7,30
  dateType: 0, // 时间类型：2-自定义，1-固定天数
  devicePropertyId: 0, // 设备属性id
  endDateStr: "", // dateType=2自定义时的结束日期，格式：yyyy-MM-dd.
  farmId: 0,
  startDateStr: "", // dateType=2自定义时的开始日期，格式：yyyy-MM-dd
};
export const iotAccess = {
  getLiveUrlService(params = {}) {
    return send.post(snkd.produce.iotAccess.getLiveUrl, {
      ...params,
    });
  },
  cameraListService({ farmId, pageSize, pageNo } = CoCameraListReq) {
    return send.post(snkd.produce.iotAccess.cameraList, {
      farmId,
      pageSize,
      pageNo,
    });
  },

  deviceListService({ farmId, pageSize, pageNo } = CoDeviceListReq) {
    return send.post(snkd.produce.iotAccess.deviceList, {
      farmId,
      pageSize,
      pageNo,
    });
  },

  deviceDetailService({ farmId, deviceId } = CoDeviceDetailReq) {
    return send.post(snkd.produce.iotAccess.deviceDetail, {
      farmId,
      deviceId,
    });
  },

  propertyGetService({
    farmId,
    deviceId,
    devicePropertyId,
  } = CoDevicePropertyGetReq) {
    return send.post(snkd.produce.iotAccess.propertyGet, {
      farmId,
      deviceId,
      devicePropertyId,
    });
  },

  devicePropertyHistoryService({
    dateNum,
    dateType,
    devicePropertyId,
    endDateStr,
    farmId,
    startDateStr,
  } = CoDeviceAttrHistoryReq) {
    return send.post(snkd.produce.iotAccess.devicePropertyHistory, {
      dateNum,
      dateType,
      devicePropertyId,
      endDateStr,
      farmId,
      startDateStr,
    });
  },
};

export const iotAccessThird = {
  deviceListService({ farmId, pageSize, pageNo } = CoDeviceDetailReq) {
    return send.post(snkd.produce.iotAccessThird.deviceList, {
      farmId,
      pageSize,
      pageNo,
    });
  },
  deviceGetDetailService({ farmId, deviceId } = CoDeviceDetailReq) {
    return send.post(snkd.produce.iotAccessThird.deviceGetDetail, {
      farmId,
      deviceId,
    });
  },
};

const CoLandGetHasPathReq = {
  companyId: 0,
  farmId: 0,
};

export const farm = {
  /**
   * @description 获取农场详情
   * @param companyId{number} 企业id
   * @param farmId{number} 农场id
   * @returns {Promise<*>}
   */
  getService({ companyId, farmId } = CoLandGetHasPathReq) {
    return send.post(snkd.produce.farm.get, { companyId, farmId });
  },
  getMapService({ companyId, farmId } = CoLandGetHasPathReq) {
    return send.post(snkd.produce.farm.getMap, { companyId, farmId });
  },
  /***
   * @description 农场概览
   * @param companyId (integer, optional): 企业id
   * @param farmId (integer, optional): 农场id
   * @returns {Promise<*>}
   */
  statisticsFarmAcreAndOnPlantingAcreService(
    { companyId, farmId } = {
      companyId: "",
      farmId: "",
    }
  ) {
    return send.post(snkd.produce.farm.statisticsFarmAcreAndOnPlantingAcre, {
      companyId,
      farmId,
    });
  },
  /**
   * @description 获取当前种养品种
   * @param companyId{number} 企业id
   * @param farmId{number} 农场id
   * @returns {Promise<*>}
   */
  onPlantingByFarmIdService({ companyId, farmId } = CoLandGetHasPathReq) {
    return send.post(snkd.produce.farm.onPlantingByFarmId, {
      companyId,
      farmId,
    });
  },
  /**
   * @description 获取绿色食品证书列表
   * @param farmId{number} 农场id
   * @returns {Promise<*>}
   */
  queryByFarmIdService({ farmId } = { farmId: 0 }) {
    return send.post(snkd.produce.farm.queryByFarmId, {
      farmId,
    });
  },
  sumAwaitInsureOrderLandAcreService(params) {
    return send.post(snkd.produce.farm.sumAwaitInsureOrderLandAcre, params);
  },
};

// 作物
export const crop = {
  /***
   * @description 农场概览
   * @param companyId (integer, optional): 企业id
   * @param farmId (integer, optional): 农场id
   * @param cropSubjectIdentifierList (Array[string], optional): 作物大类数组：agri-农业，forestry-林业，animal-牧业，fishery-渔业 ,传空数组，查询全部
   * @param plantStatus (integer, optional): 种植状态：1-计划种植，2-当前种植，3-历史种植 ,为null，查询全部
   * @returns {Promise<*>}
   */
  listOfCurrencyService(
    { companyId, farmId, cropSubjectIdentifierList, plantStatus } = {
      companyId: "",
      farmId: "",
      cropSubjectIdentifierList: [],
      plantStatus: null,
    }
  ) {
    return send.post(snkd.produce.crop.listOfCurrency, {
      companyId,
      farmId,
      cropSubjectIdentifierList,
      plantStatus,
    });
  },
};

// 溯源（农业）
export const qrCodeAgri = {
  /***
   * @description 溯源-列表
   * @param companyId (integer, optional): 企业id
   * @param farmId (integer, optional): 农场id
   * @param pageNo (integer, optional): 第几页，从1开始 ,
   * @param pageSize (integer, optional): 每页个数
   * @returns {Promise<*>}
   */
  listByFarmIdService(
    { companyId, farmId, pageNo, pageSize } = {
      companyId: "",
      farmId: "",
      pageNo: 0,
      pageSize: 0,
    }
  ) {
    return send.post(snkd.produce.qrCodeAgri.listByFarmId, {
      companyId,
      farmId,
      pageNo,
      pageSize,
    });
  },
  /***
   * @description 溯源（农业）-详情
   * @param companyId (integer, optional): 企业id
   * @param farmId (integer, optional): 农场id
   * @param pickId (integer, optional): 采收记录id
   * @returns {Promise<*>}
   */
  getByPickIdService(
    { companyId, farmId, pickId } = {
      companyId: "",
      farmId: "",
      pickId: 0,
    }
  ) {
    return send.post(snkd.produce.qrCodeAgri.getByPickId, {
      companyId,
      farmId,
      pickId,
    });
  },
};

// 溯源
export const qrCode = {
  /***
   * @description 溯源-列表
   * @param companyId (integer, optional): 企业id
   * @param farmId (integer, optional): 农场id
   * @returns {Promise<*>}
   */
  listByFarmIdService(
    { companyId, farmId } = {
      companyId: "",
      farmId: "",
    }
  ) {
    return send.post(snkd.produce.qrCode.listByFarmId, {
      companyId,
      farmId,
    });
  },
};

export const farmRealTimeDynamic = {
  /***
   * @description v3.25.0生产统计本年农事操作
   * @param farmIds  (integer, optional): 农场ID
   * @param pageNo  (integer, optional): 页码
   * @param pageSize  (integer, optional): 条数
   * @returns {Promise<*>}
   */
  listByFarmIdsService(
    { farmId, pageNo, pageSize } = {
      farmId: 0,
      pageNo: 0,
      pageSize: 0,
    }
  ) {
    return send.post(snkd.produce.farmRealTimeDynamic.listByFarmId, {
      farmId,
      pageNo,
      pageSize,
    });
  },
};

const CoLandBroadenGetReq = {
  companyId: 0,
  farmId: 0,
  landId: 0,
};
export const landBroaden = {
  getService({ companyId, farmId, landId } = CoLandBroadenGetReq) {
    return send.post(snkd.produce.landBroaden.get, {
      companyId,
      farmId,
      landId,
    });
  },
};

export const getFarmAllScore = () => {
  return axios.post(snkd.produce.farmScoreDetail.getScore, {
    companyId,
    farmId,
  });
};

export const policyOverview = (params) => {
  return send.post(snkd.produce.farmInsurePolicy.policyOverview, params);
};

export const insureCalendarFifteenDayList = (params) => {
  return send.post(
    snkd.produce.farmInsurePolicy.insureCalendarFifteenDayList,
    params
  );
};

// 农作物相关服务
export const cropService = {
  /**
   * @description 获取采收库存-作物最晚采收日期
   * @param { Object } params 查询参数
   * @param { Number } params.farmId 农场id
   * @param { Number } params.companyId 企业id
   * @param { Array }  params.cropId 作物列表id
   * @returns { Promise<{*}> }
   */
  async getLatestPickTime(params = {}) {
    const res = await axios.post(snkd.produce.crop.getLatestPickTime, params);
    if (res.respCode === 0) {
      return res.obj;
    }
    throw res;
  },

  /**
   * @description 外采库存-作物最晚采收日期
   * @param { Object } params 查询参数
   * @param { Number } params.farmId 农场id
   * @param { Array }  params.cropId 作物列表id
   * @returns { Promise<{*}> }
   */
  async getLatestOutsourcingTime(params = {}) {
    const res = await axios.post(
      snkd.produce.crop.getLatestOutsourcingTime,
      params
    );
    if (res.respCode === 0) {
      return res.obj;
    }
    throw res;
  },

  async listAllShort(params = {}) {
    const res = await axios.post(snkd.produce.crop.listAllShort, params);
    if (res.respCode === 0) {
      return res.obj;
    }
    throw res;
  },

  async addFeedback(params = {}) {
    const res = await axios.post(snkd.produce.crop.addFeedback, params);
    if (res.respCode === 0) {
      return res.obj;
    }
    throw res;
  },
  async getListByLayered(params = {}) {
    const res = await axios.post(snkd.produce.crop.getListByLayered, params);
    if (res.respCode === 0) {
      return res.obj;
    }
    throw res;
  },
};

export const expertConsultation = {
  async queryPageList(params = {}) {
    const res = await axios.post(
      snkd.produce.expertConsultation.queryPageList,
      params
    );
    if (res.respCode === 0) {
      return res.obj;
    }
    throw res;
  },
  async quizSave(params = {}) {
    const res = await axios.post(
      snkd.produce.expertConsultation.quizSave,
      params
    );
    if (res.respCode === 0) {
      return res.obj;
    }
    throw res;
  },
  async updateToRemove(id) {
    const res = await axios.get(
      `${snkd.produce.expertConsultation.updateToRemove}/${id}`
    );
    if (res.respCode === 0) {
      return res.obj;
    }
    throw res;
  },
  async probeSave(params = {}) {
    const res = await axios.post(
      snkd.produce.expertConsultation.probeSave,
      params
    );
    if (res.respCode === 0) {
      return res.obj;
    }
    throw res;
  },
  async probeDelete(id) {
    const res = await axios.get(
      `${snkd.produce.expertConsultation.probeDelete}/${id}`
    );
    if (res.respCode === 0) {
      return res.obj;
    }
    throw res;
  },
};
